import { ColorOptions } from '../../../types/colorOptions';
import { ReactLink } from '../atoms/ReactLink';

export interface LinkComponentProps {
	label?: string;
	url?: string;
	icon?: React.ReactNode;
	className?: string;
	children?: React.ReactNode | React.ReactNode[];
	options?: ColorOptions;
}

export const LinkComponent = ({
	label,
	url,
	icon,
	className,
	children,
	options,
}: LinkComponentProps) => (
	<ReactLink
		label={label}
		url={url}
		icon={icon}
		children={children}
		className={className}
		options={options}
	/>
);
